import React, { useState } from 'react'
import SidebarNew from '../SidebarNew/SidebarNew'
import { Box, Grid, Button, useTheme, useMediaQuery, styled, Tabs, Tab, Typography, Avatar, TextField } from '@mui/material';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';
import bk1 from '../../img/dster-webp/bk1.webp'
import Divider from '@mui/material/Divider';
// import { useLocation } from 'react-router-dom';
import Radio from '@mui/material/Radio';
import { SvgIcon } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Modal from '@mui/material/Modal';
import Switch from '@mui/material/Switch';
import LockIcon from '@mui/icons-material/Lock';
import GroupIcon from '@mui/icons-material/Group';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

const style3 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "400px",
    // height: '460px',
    '@media(max-width:991.98px)': {
        width: '80%',
    },
    background: 'linear-gradient(274.4deg, #175AFF 2.38%, #FC5AFF 97.31%)',
    // border: '2px solid #175AFF',
    // boxShadow: 24,xdfcfv bnm,
    borderRadius: '12px',

    p: '1px',
};

const style2 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "500px",
    // height: '460px',
    '@media(max-width:991.98px)': {
        width: '80%',
    },
    background: 'linear-gradient(274.4deg, #175AFF 2.38%, #FC5AFF 97.31%)',
    // border: '2px solid #175AFF',
    // boxShadow: 24,xdfcfv bnm,
    borderRadius: '12px',

    p: '1px',
};

const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(12px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : 'green',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 12,
        height: 12,
        borderRadius: 6,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor:
            theme.palette.mode === 'dark' ? 'green' : 'red',
        boxSizing: 'border-box',
    },
}));


function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});


function BckPassCreate() {

    const theme = useTheme();
    const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));

    const MobileView = useMediaQuery(theme.breakpoints.up('sm'));
    const [name, setName] = useState()

    // const [,] = usestate()

    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [value2, setValue2] = useState(0);

    const handleChange2 = (event, newValue) => {
        setValue2(newValue);
    };

    const [value3, setValue3] = useState(0);

    const handleChange3 = (event, newValue) => {
        setValue3(newValue);
    };
    // const location = useLocation()

    // const result = location.state

    const [imageUrl, setImageUrl] = useState(null);

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        console.log(reader, "result of file");

        reader.onloadend = () => {
            setImageUrl(reader.result);
        };

        if (file) {
            reader.readAsDataURL(file);
        }
    };

    const uploadImageDiv = (
        <Button
            component="label"
            role={undefined}
            // variant="contained"
            tabIndex={-1}
            // startIcon={<CloudUploadIcon />}
            sx={{ width: '100%' }}>
            <div className="uplaodNullImage">
                Upload cover photo
            </div>
            <VisuallyHiddenInput type="file" onChange={handleImageUpload} />
        </Button>

    )


    const [setting, setSetting] = useState(false)

    const handleSetting = () => {
        setSetting(!setting)
    }
    const [recent] = useState([
        {},
        {},
        {},
        {},
        {},
        {},

    ])
    const [selectedColor, setSelectedColor] = useState('#0693E3');

    const handleColorChange = (event) => {
        setSelectedColor(event.target.value);
    };

    const [selectedValue, setSelectedValue] = React.useState(null);

    const handleChangePvt = (event) => {
        setSelectedValue(event.target.value);
    };

    const GradientMoreHorizIcon = () => {
        return (
            <SvgIcon>
                {/* Define the linear gradient */}
                <defs>
                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" style={{ stopColor: '#175AFF', stopOpacity: 1 }} />
                        <stop offset="100%" style={{ stopColor: '#FC5AFF', stopOpacity: 1 }} />
                    </linearGradient>
                </defs>
                {/* Use the MoreHorizIcon and apply the gradient */}
                <MoreHorizIcon sx={{ fill: 'url(#gradient1)' }} />
            </SvgIcon>
        );
    };


    const [pg, setPg] = useState(0)

    const handlePg = (val) => {
        setPg(val)
    }
    const [selectAge, setSelectAge] = useState(10);

    const handleSelectAge = (event) => {
        setSelectAge(event.target.value);
    };

    const [openModel3, setOpenModel3] = useState(false);

    const handleOpen3 = () => { setOpenModel3(true) };
    const handleClose4 = () => { setOpenModel3(false); setPg(0) };

    const [openModel4, setOpenModel4] = useState(false);

    const handleOpenM4 = () => { setOpenModel4(true) };
    const handleCloseM4 = () => { setOpenModel4(false) };

    const [editPlug, setEditPlug] = useState(false)
    const handleEditPlug = () => {
        setEditPlug(true)
    }

    const [switc, setSwitc] = useState(false)

    const handleSwitc = () => {
        setSwitc(!switc)
        // console.log(switc, 'switc');
    }

    const switchs = (

        <Stack direction="row" spacing={1} alignItems="center">

            <AntSwitch inputProps={{ 'aria-label': 'ant design' }} onChange={handleSwitc} />
            <Typography style={{
                color: switc ? '#51DC8E' : 'red'
            }}>{switc ? 'ON' : "OFF"}</Typography>
        </Stack>

    )
    return (
        <div className='bckpasscreate'>
            <Box sx={{ display: isLgUp ? 'flex' : 'block' }}>
                <SidebarNew name={name} setName={setName} />
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        py: 1,
                        // width: { sm: `calc(100% - ${drawerWidth}px)` },
                        marginTop: "80px",
                    }}
                >
                    <div className="display-2 flex-c">
                        <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
                            <div className="display-1">
                                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_4403_3112)">
                                        <path d="M15 2.8125C12.5895 2.8125 10.2332 3.52728 8.22899 4.86646C6.22477 6.20564 4.66267 8.10907 3.74022 10.336C2.81778 12.563 2.57643 15.0135 3.04668 17.3777C3.51694 19.7418 4.67769 21.9134 6.38214 23.6179C8.08659 25.3223 10.2582 26.4831 12.6223 26.9533C14.9865 27.4236 17.437 27.1822 19.664 26.2598C21.8909 25.3373 23.7944 23.7752 25.1335 21.771C26.4727 19.7668 27.1875 17.4105 27.1875 15C27.1841 11.7687 25.899 8.67076 23.6141 6.3859C21.3292 4.10104 18.2313 2.81591 15 2.8125ZM17.5383 19.0242C17.6254 19.1113 17.6945 19.2147 17.7416 19.3285C17.7888 19.4423 17.813 19.5643 17.813 19.6875C17.813 19.8107 17.7888 19.9327 17.7416 20.0465C17.6945 20.1603 17.6254 20.2637 17.5383 20.3508C17.4512 20.4379 17.3478 20.507 17.234 20.5541C17.1202 20.6013 16.9982 20.6255 16.875 20.6255C16.7518 20.6255 16.6298 20.6013 16.516 20.5541C16.4022 20.507 16.2988 20.4379 16.2117 20.3508L11.5242 15.6633C11.4371 15.5762 11.3679 15.4728 11.3207 15.359C11.2736 15.2452 11.2493 15.1232 11.2493 15C11.2493 14.8768 11.2736 14.7548 11.3207 14.641C11.3679 14.5272 11.4371 14.4238 11.5242 14.3367L16.2117 9.64922C16.2988 9.56212 16.4022 9.49302 16.516 9.44588C16.6298 9.39874 16.7518 9.37448 16.875 9.37448C16.9982 9.37448 17.1202 9.39874 17.234 9.44588C17.3478 9.49302 17.4512 9.56212 17.5383 9.64922C17.6254 9.73632 17.6945 9.83973 17.7416 9.95353C17.7888 10.0673 17.813 10.1893 17.813 10.3125C17.813 10.4357 17.7888 10.5577 17.7416 10.6715C17.6945 10.7853 17.6254 10.8887 17.5383 10.9758L13.5129 15L17.5383 19.0242Z" fill="#45413F" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4403_3112">
                                            <rect width="30" height="30" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>

                                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_4403_3109)">
                                        <path d="M15 2.8125C12.5895 2.8125 10.2332 3.52728 8.22899 4.86646C6.22477 6.20564 4.66267 8.10907 3.74022 10.336C2.81778 12.563 2.57643 15.0135 3.04668 17.3777C3.51694 19.7418 4.67769 21.9134 6.38214 23.6179C8.08659 25.3223 10.2582 26.4831 12.6223 26.9533C14.9865 27.4236 17.437 27.1822 19.664 26.2598C21.8909 25.3373 23.7944 23.7752 25.1335 21.771C26.4727 19.7668 27.1875 17.4105 27.1875 15C27.1841 11.7687 25.899 8.67076 23.6141 6.3859C21.3292 4.10104 18.2313 2.81591 15 2.8125ZM18.4758 15.6633L13.7883 20.3508C13.7012 20.4379 13.5978 20.507 13.484 20.5541C13.3702 20.6013 13.2482 20.6255 13.125 20.6255C13.0018 20.6255 12.8798 20.6013 12.766 20.5541C12.6522 20.507 12.5488 20.4379 12.4617 20.3508C12.3746 20.2637 12.3055 20.1603 12.2584 20.0465C12.2112 19.9327 12.187 19.8107 12.187 19.6875C12.187 19.5643 12.2112 19.4423 12.2584 19.3285C12.3055 19.2147 12.3746 19.1113 12.4617 19.0242L16.4871 15L12.4617 10.9758C12.2858 10.7999 12.187 10.5613 12.187 10.3125C12.187 10.0637 12.2858 9.82513 12.4617 9.64922C12.6376 9.47331 12.8762 9.37448 13.125 9.37448C13.3738 9.37448 13.6124 9.47331 13.7883 9.64922L18.4758 14.3367C18.563 14.4238 18.6321 14.5272 18.6793 14.641C18.7265 14.7548 18.7507 14.8768 18.7507 15C18.7507 15.1232 18.7265 15.2452 18.6793 15.359C18.6321 15.4728 18.563 15.5762 18.4758 15.6633Z" fill="#45413F" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_4403_3109">
                                            <rect width="30" height="30" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>

                            </div>
                            <div className="tg" style={{
                                background: selectedColor ? selectedColor : "linear-gradient(274.4deg, #175AFF 2.38%, #FC5AFF 97.31%)"
                            }}>

                                TG
                            </div>
                            <div className="tsetgrp">
                                Test Group
                            </div>
                            <div className="">
                                <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.2973 6.70738C10.907 7.10048 10.2715 7.10158 9.87984 6.70988L7.41405 4.24408C6.633 3.46308 5.36668 3.46308 4.58563 4.24408L2.11984 6.70988C1.72814 7.10158 1.09264 7.10048 0.702339 6.70738C0.313939 6.31628 0.315039 5.68468 0.704839 5.29488L4.58563 1.41408C5.36667 0.633078 6.633 0.633078 7.41405 1.41408L11.2948 5.29488C11.6846 5.68468 11.6857 6.31628 11.2973 6.70738Z" fill="#909090" />
                                    <path d="M0.70234 12.7127C1.09264 12.3196 1.72814 12.3185 2.11984 12.7102L4.58563 15.176C5.36668 15.9571 6.633 15.9571 7.41405 15.176L9.87984 12.7102C10.2715 12.3185 10.907 12.3196 11.2973 12.7127C11.6857 13.1039 11.6846 13.7355 11.2948 14.1252L7.41405 18.006C6.63301 18.7871 5.36668 18.7871 4.58563 18.006L0.704839 14.1252C0.315039 13.7355 0.31394 13.1039 0.70234 12.7127Z" fill="#909090" />
                                </svg>

                            </div>
                        </Stack>

                        {setting ? <Box sx={{ width: '100%' }}>
                            <Box>
                                <Tabs value={value3} onChange={handleChange3} aria-label="basic tabs example" className='bck-tab2 settings-tab' variant="scrollable"
                                    scrollButtons
                                    allowScrollButtonsMobile>
                                    <Tab label="Dashboard" {...a11yProps(0)} />
                                    <Tab label="General" {...a11yProps(1)} />
                                    <Tab label="Subscriptions" {...a11yProps(2)} />
                                    <Tab label="Categories" {...a11yProps(3)} />
                                    <Tab label="Plugins" {...a11yProps(4)} />
                                    <Tab label="Gamification" {...a11yProps(5)} />
                                </Tabs>
                            </Box>

                        </Box> : <Box sx={{ width: '100%' }} >
                            <Box>
                                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className='bck-tab' variant="scrollable"
                                    scrollButtons
                                    allowScrollButtonsMobile>
                                    <Tab label="Community" {...a11yProps(0)} />
                                    <Tab label="Members" {...a11yProps(1)} />
                                    <Tab label="Leaderboards" {...a11yProps(2)} />
                                    <Tab label="About" {...a11yProps(3)} />
                                </Tabs>
                            </Box>

                        </Box>}


                    </div>
                    <Grid container spacing={0}>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={setting ? 12 : 8}
                            style={{ padding: '20px' }}
                        >

                            {/* <div className=""></div> */}

                            {setting ? <>

                                <CustomTabPanel value={value3} index={0}>
                                    <Grid container className="dashboard-body">
                                        <Grid xs={12} sx={12} md={12} lg={12} xl={9}>
                                            <div className="dashboard-head">
                                                Happy Saturday, <span>tarisa</span>
                                            </div>
                                            {/* style={{ gap: '30px' }} */}
                                            <div className="display-1 flex-c">
                                                <div className="layerdiv">
                                                    <div className="dsh-statu">
                                                        <img src={bk1} alt="" />
                                                        <div className="dsh-num">73</div>
                                                        <div className="Pai-members">
                                                            Paid members
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="layerdiv">
                                                    <div className="dsh-statu">
                                                        <img src={bk1} alt="" />
                                                        <div className="dsh-num">$17,784</div>
                                                        <div className="Pai-members">
                                                            MRR
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </Grid>
                                        <Grid xs={12} sx={12} md={12} lg={12} xl={3}>
                                            <div className="creatchat">
                                                <Button>
                                                    <div className="display-1">
                                                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M5.32692 8.49955C5.64555 8.49955 5.90385 8.24125 5.90385 7.92263C5.90385 7.604 5.64555 7.3457 5.32692 7.3457C5.0083 7.3457 4.75 7.604 4.75 7.92263C4.75 8.24125 5.0083 8.49955 5.32692 8.49955Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M9.07692 8.49955C9.39555 8.49955 9.65385 8.24125 9.65385 7.92263C9.65385 7.604 9.39555 7.3457 9.07692 7.3457C8.7583 7.3457 8.5 7.604 8.5 7.92263C8.5 8.24125 8.7583 8.49955 9.07692 8.49955Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M12.8269 8.49955C13.1455 8.49955 13.4038 8.24125 13.4038 7.92263C13.4038 7.604 13.1455 7.3457 12.8269 7.3457C12.5083 7.3457 12.25 7.604 12.25 7.92263C12.25 8.24125 12.5083 8.49955 12.8269 8.49955Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M5.61538 14.8462L1 16L2.15385 12.5385V2.15385C2.15385 1.84783 2.27541 1.55434 2.4918 1.33795C2.70819 1.12157 3.00167 1 3.30769 1H14.8462C15.1522 1 15.4457 1.12157 15.662 1.33795C15.8784 1.55434 16 1.84783 16 2.15385V13.6923C16 13.9983 15.8784 14.2918 15.662 14.5082C15.4457 14.7246 15.1522 14.8462 14.8462 14.8462H5.61538Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                        <div>
                                                            create your group
                                                        </div>
                                                    </div>
                                                </Button>
                                            </div>
                                            <div className="comchat">
                                                Community chat
                                            </div>
                                            <>
                                                <div className='topartist-recent'>
                                                    grub chat
                                                </div>
                                                <div className='height-prop' style={{ height: '50vh', overflowY: 'scroll' }}>
                                                    {recent.map((row, i) => {
                                                        return (
                                                            <div className='display-2 recente-head-div beta'>
                                                                <div className='display-1 '>
                                                                    <Avatar
                                                                        alt="Remy Sharp"
                                                                        src="https://s.france24.com/media/display/451ed2b8-eed6-11ea-afdd-005056bf87d6/w:1280/p:4x3/messi-1805.jpg"
                                                                        sx={{ width: 40, height: 40 }}
                                                                    />
                                                                    <div>
                                                                        <div className='recent-head-artist beta'>
                                                                            track pop
                                                                        </div>
                                                                        <div className='recent-head-domainbeta'>
                                                                            500+ members join chat
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div>

                                                                    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M5.32692 10.5C5.64555 10.5 5.90385 10.2417 5.90385 9.92311C5.90385 9.60449 5.64555 9.34619 5.32692 9.34619C5.0083 9.34619 4.75 9.60449 4.75 9.92311C4.75 10.2417 5.0083 10.5 5.32692 10.5Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M9.07692 10.5C9.39555 10.5 9.65385 10.2417 9.65385 9.92311C9.65385 9.60449 9.39555 9.34619 9.07692 9.34619C8.7583 9.34619 8.5 9.60449 8.5 9.92311C8.5 10.2417 8.7583 10.5 9.07692 10.5Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M12.8269 10.5C13.1455 10.5 13.4038 10.2417 13.4038 9.92311C13.4038 9.60449 13.1455 9.34619 12.8269 9.34619C12.5083 9.34619 12.25 9.60449 12.25 9.92311C12.25 10.2417 12.5083 10.5 12.8269 10.5Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M5.61538 16.8462L1 18L2.15385 14.5385V4.15385C2.15385 3.84783 2.27541 3.55434 2.4918 3.33795C2.70819 3.12157 3.00167 3 3.30769 3H14.8462C15.1522 3 15.4457 3.12157 15.662 3.33795C15.8784 3.55434 16 3.84783 16 4.15385V15.6923C16 15.9983 15.8784 16.2918 15.662 16.5082C15.4457 16.7246 15.1522 16.8462 14.8462 16.8462H5.61538Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <circle cx="17" cy="3" r="3" fill="#00F218" />
                                                                    </svg>



                                                                </div>
                                                            </div>
                                                        )
                                                    })}

                                                </div>
                                            </>
                                        </Grid>
                                    </Grid>
                                </CustomTabPanel>
                                <CustomTabPanel value={value3} index={1} className="General">
                                    <Grid container>
                                        <Grid xs={12} sx={12} md={12} lg={8} xl={9}>
                                            <div className="display-2 upload-flex" style={{ flexWrap: 'wrap' }}>
                                                <div className="display-1 upload-div" style={{ alignItems: 'flex-start' }}>
                                                    <div className="up1">
                                                        {/* <p>Upload</p> */}
                                                        {imageUrl && <img src={imageUrl} alt="imagurl" />}
                                                    </div>
                                                    <div className="Icon" style={{ marginTop: '20px' }}>
                                                        Icon

                                                        <div className="reso">
                                                            Recommended:
                                                            <div className='reso'>
                                                                128 x 128
                                                            </div>
                                                            <div className="change-btn">
                                                                <Button
                                                                    component="label"
                                                                    role={undefined}
                                                                    sx={{
                                                                        width: '100%', padding: '15px', marginTop: '10px'
                                                                    }}
                                                                    // variant="contained"
                                                                    tabIndex={- 1
                                                                    }
                                                                >
                                                                    Change

                                                                    < VisuallyHiddenInput type="file" onChange={handleImageUpload} />
                                                                </Button>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                                <div className="display-1 upload-div upload-big-img" style={{ alignItems: 'flex-end' }}>
                                                    <div className="up2" style={{ width: !MobileView && "100%", height: !MobileView && '200px' }}>
                                                        {imageUrl && <img src={imageUrl} alt="imagurl" />}
                                                    </div>
                                                    <div className="Icon" style={{ marginTop: '20px' }}>
                                                        Icon

                                                        <div className="reso">
                                                            Recommended:
                                                            <div className='reso'>
                                                                128 x 128
                                                            </div>
                                                            <div className="change-btn">
                                                                <Button
                                                                    component="label"
                                                                    role={undefined}
                                                                    sx={{ width: '300px', padding: '15px', marginTop: '10px' }}
                                                                    // variant="contained"
                                                                    tabIndex={-1}
                                                                >
                                                                    Change

                                                                    <VisuallyHiddenInput type="file" onChange={handleImageUpload} />
                                                                </Button>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>

                                            <div className='group-inputs'>
                                                <div className="layerdiv">
                                                    <div className="commentinput2 display-1">
                                                        <div className='cmt2'>
                                                            <TextField id="outlined-basic" variant="outlined" placeholder='Group Name' />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="layerdiv">
                                                    <div className="commentinput2 display-1">
                                                        <div className='cmt2'>
                                                            <TextField id="outlined-basic" variant="outlined" placeholder='URL' />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="upgrae">
                                                    You can change your URL with a paid account.<span>Upgrade now?</span> </div>
                                                <div className="layerdiv">
                                                    <div className="commentinput2 display-1">
                                                        <div className='cmt2'>
                                                            <TextField id="outlined-basic" variant="outlined" placeholder=' Group description' multiline rows={6} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Grid>
                                        {/* <Grid xs={0} sx={0} md={0} lg={0} xl={1}></Grid> */}
                                        <Grid xs={12} sx={12} md={12} lg={4} xl={3}>
                                            <div>
                                                <div className="layerdiv">
                                                    <div className="commentinput2 display-1">

                                                        <div className='cmt2'>
                                                            <TextField id="outlined-basic" variant="outlined" placeholder='Initials' />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="display-1" style={{ alignItems: 'flex-end' }}>
                                                    <div >
                                                        <input
                                                            type="color"
                                                            className='cursor'
                                                            value={selectedColor}
                                                            onChange={handleColorChange}
                                                            style={{ width: '90px', height: '70px', background: 'transparent', borderRadius: '20px' }}

                                                        />
                                                    </div>
                                                    <div className="layerdiv">
                                                        <div className="commentinput2 display-1">

                                                            <div className='cmt2'>
                                                                <TextField id="outlined-basic" variant="outlined" value={selectedColor} onChange={handleColorChange} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="display-2" style={{ justifyContent: 'center', gap: '15px', marginTop: '15px' }}>
                                                <div className="pvt">
                                                    <div className="display-1" style={{ margin: '15px 0px' }}>
                                                        <div>
                                                            <Radio
                                                                checked={selectedValue === 'a'}
                                                                onChange={handleChangePvt}
                                                                value="a"
                                                                name="radio-buttons"
                                                                className='pvt-radio'
                                                                inputProps={{ 'aria-label': 'A' }}
                                                            />
                                                        </div>
                                                        <div style={{ display: 'flex' }}>
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M19.5 14.25C19.5 13.6533 19.2629 13.081 18.841 12.659C18.419 12.2371 17.8467 12 17.25 12H6.75C6.15326 12 5.58097 12.2371 5.15901 12.659C4.73705 13.081 4.5 13.6533 4.5 14.25V15C4.5 17.9565 7.29 21 12 21C14.5965 21 16.6095 20.0745 17.8935 18.75H12V19.5C8.148 19.5 6 17.157 6 15V14.25C6 14.0511 6.07902 13.8603 6.21967 13.7197C6.36032 13.579 6.55109 13.5 6.75 13.5H12V14.25H19.5ZM18.96 17.25H12V15.75H19.44C19.3605 16.26 19.1985 16.767 18.96 17.25ZM16.125 6.375C16.125 6.119 16.1025 5.869 16.0575 5.625H12V7.125H16.0575C16.1025 6.881 16.125 6.631 16.125 6.375ZM12 2.25C13.4475 2.25 14.7225 2.9955 15.4575 4.125H12V3.75C11.3038 3.75 10.6361 4.02656 10.1438 4.51884C9.65156 5.01113 9.375 5.67881 9.375 6.375C9.375 7.07119 9.65156 7.73887 10.1438 8.23116C10.6361 8.72344 11.3038 9 12 9V8.625H15.4575C15.0676 9.22407 14.5288 9.71155 13.8938 10.0397C13.2588 10.3678 12.5494 10.5253 11.8353 10.4967C11.1211 10.4681 10.4266 10.2545 9.81982 9.87667C9.21307 9.49887 8.71489 8.96989 8.37413 8.34159C8.03337 7.71329 7.86172 7.00723 7.87599 6.29261C7.89027 5.578 8.08999 4.87935 8.45557 4.26516C8.82115 3.65097 9.34005 3.14232 9.9614 2.78905C10.5828 2.43578 11.2852 2.25003 12 2.25Z" fill="white" />
                                                            </svg>

                                                        </div>
                                                        <div className="pvt-tx">
                                                            Private
                                                        </div>
                                                    </div>
                                                    <div className="pvt-des">
                                                        Only members can see who's in the group and what they post. Content is hidden from search engines.
                                                    </div>

                                                </div>
                                                <div className="layerdiv2">
                                                    <div className="pvt">
                                                        <div className="display-1" style={{ margin: '15px 0px' }}>
                                                            <div>
                                                                <Radio
                                                                    checked={selectedValue === 'b'}
                                                                    onChange={handleChangePvt}
                                                                    value="b"
                                                                    name="radio-buttons"
                                                                    inputProps={{ 'aria-label': 'B' }}
                                                                    className='pbu-radio'
                                                                />
                                                            </div>
                                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9.00202 18.002C7.75789 18.002 6.58776 17.7659 5.49164 17.2939C4.39619 16.8212 3.44309 16.1798 2.63233 15.3697C1.82158 14.5596 1.17984 13.6075 0.707124 12.5134C0.234406 11.4192 -0.00195312 10.2494 -0.00195312 9.00398C-0.00195313 7.75851 0.234406 6.58838 0.707124 5.4936C1.17918 4.39814 1.81958 3.44504 2.62833 2.63429C3.43709 1.82353 4.38952 1.18179 5.48564 0.709077C6.58176 0.236359 7.75189 0 8.99602 0C10.2402 0 11.4103 0.236359 12.5064 0.709077C13.6019 1.18113 14.555 1.82186 15.3657 2.63129C16.1765 3.44071 16.8182 4.39314 17.2909 5.48859C17.7636 6.58405 18 7.75384 18 8.99797C18 10.2421 17.764 11.4122 17.2919 12.5084C16.8199 13.6045 16.1785 14.5576 15.3677 15.3677C14.557 16.1778 13.6049 16.8195 12.5114 17.2929C11.418 17.7663 10.2482 18.0026 9.00202 18.002ZM7.99891 16.9518V15.0016C7.44885 15.0016 6.97814 14.8059 6.58676 14.4146C6.19539 14.0232 5.99936 13.5521 5.9987 13.0014V12.0013L1.19818 7.20078C1.14817 7.50081 1.1025 7.80085 1.06116 8.10088C1.01982 8.40091 0.998822 8.70094 0.998155 9.00098C0.998155 11.0179 1.66089 12.7847 2.98637 14.3015C4.31185 15.8184 5.9827 16.7018 7.99891 16.9518ZM14.8997 14.4016C15.233 14.0349 15.5331 13.6391 15.7998 13.2144C16.0665 12.7897 16.2871 12.348 16.4618 11.8893C16.6365 11.4306 16.7699 10.9595 16.8619 10.4761C16.9539 9.99275 16.9999 9.50103 16.9999 9.00098C16.9999 7.35813 16.5488 5.85764 15.6467 4.49949C14.7446 3.14134 13.5288 2.16223 11.9993 1.56217V2.00022C11.9993 2.55028 11.8037 3.02133 11.4123 3.41337C11.0209 3.80541 10.5499 4.0011 9.99913 4.00043H7.99891V6.00065C7.99891 6.28401 7.9029 6.52171 7.71088 6.71373C7.51886 6.90575 7.2815 7.00143 6.99881 7.00076H4.99859V9.00098H10.9992C11.2826 9.00098 11.5203 9.09699 11.7123 9.28901C11.9043 9.48103 12 9.71839 11.9993 10.0011V13.0014H12.9995C13.4328 13.0014 13.8245 13.1308 14.1746 13.3895C14.5246 13.6481 14.7663 13.9855 14.8997 14.4016Z" fill="url(#paint0_linear_4403_3416)" />
                                                                <defs>
                                                                    <linearGradient id="paint0_linear_4403_3416" x1="17.6785" y1="16.1736" x2="-0.615794" y2="14.7659" gradientUnits="userSpaceOnUse">
                                                                        <stop stop-color="#175AFF" />
                                                                        <stop offset="1" stop-color="#FC5AFF" />
                                                                    </linearGradient>
                                                                </defs>
                                                            </svg>
                                                            <div className="pvt-tx pub">
                                                                Public
                                                            </div>
                                                        </div>
                                                        <div className="pvt-des">
                                                            Only members can see who's in the group and what they post. Content is hidden from search engines.
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </Grid>
                                    </Grid>

                                    {/* <Grid container>
                                        <Grid xs={12} sx={12} md={12} lg={8} xl={8}>
                                            <div className="layerdiv">
                                                <div className="commentinput2 display-1">
                                                    <div className='cmt2'>
                                                        <TextField id="outlined-basic" variant="outlined" placeholder='Group Name' />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="layerdiv">
                                                <div className="commentinput2 display-1">
                                                    <div className='cmt2'>
                                                        <TextField id="outlined-basic" variant="outlined" placeholder='URL' />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="upgrae">
                                                You can change your URL with a paid account.<span>Upgrade now?</span> </div>
                                            <div className="layerdiv">
                                                <div className="commentinput2 display-1">
                                                    <div className='cmt2'>
                                                        <TextField id="outlined-basic" variant="outlined" placeholder=' Group description' multiline rows={6} />
                                                    </div>
                                                </div>
                                            </div>
                                        </Grid>
                                        
                                        <div className='upload-next-btn pun text-center' >
                                            <Button>
                                                Publish
                                            </Button>
                                        </div>
                                    </Grid> */}


                                </CustomTabPanel>
                                <CustomTabPanel value={value3} index={2} className="subscription">
                                    <div className="subsc">
                                        Subscriptions
                                    </div>
                                    <div className="subsc-p">
                                        Make money by charging a monthly subscription for access to your community.
                                    </div>
                                    <div className="display-1">
                                        <div className="layerdiv" style={{ width: '100%', marginTop: '0px' }}>
                                            <div className="commentinput2 display-2">
                                                <div className="display-1">
                                                    <div className=''>
                                                        <div className="display-1">
                                                            <div className="tg" style={{
                                                                background: selectedColor ? selectedColor : "linear-gradient(274.4deg, #175AFF 2.38%, #FC5AFF 97.31%)"
                                                            }}>

                                                                TG
                                                            </div>
                                                            <div className="tsetgrp">
                                                                Test Group
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="upgrae">
                                                        <span>1 Member</span>
                                                    </div>
                                                </div>
                                                <div className="display-1">
                                                    <div className="crrprice">
                                                        <Button variant='contained'>
                                                            Current price
                                                        </Button>
                                                    </div>
                                                    <div>
                                                        <GradientMoreHorizIcon />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="adprice">
                                            <div className='upload-next-btn adpr text-center' >
                                                <Button onClick={handleOpen3}>
                                                    Add Price
                                                </Button>
                                            </div>
                                        </div>
                                        <Modal
                                            open={openModel3}
                                            // onClose={handleClose4}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                        >
                                            <Box sx={style3}>
                                                <div style={{ background: 'var(--clr-bcg3)', borderRadius: '12px', padding: '20px 50px', height: '100%' }}>
                                                    <div className='text-left' style={{
                                                        position: 'relative',
                                                        left: '-35px'
                                                    }}>
                                                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={handleClose4}>
                                                            < path d="M0.806643 14.4092C0.299284 13.9018 0.299285 13.0792 0.806644 12.5719L12.5719 0.806641C13.0792 0.299282 13.9018 0.299282 14.4092 0.806641C14.9165 1.314 14.9165 2.13659 14.4092 2.64395L2.64395 14.4092C2.13659 14.9165 1.314 14.9165 0.806643 14.4092ZM0.801271 2.62783C0.296879 2.12344 0.296879 1.30566 0.801271 0.801269C1.30566 0.296877 2.12344 0.296877 2.62783 0.801269L14.4146 12.588C14.9189 13.0924 14.9189 13.9102 14.4146 14.4145C13.9102 14.9189 13.0924 14.9189 12.588 14.4145L0.801271 2.62783Z" fill="white" />
                                                        </svg>
                                                    </div>
                                                    {pg === 1 ? <>

                                                        <div className='puntext'>
                                                            Add Dster Price
                                                        </div>

                                                        <div className="layerdiv">
                                                            <div className="comment2 display-1">
                                                                <div className='commentinput'>
                                                                    <TextField id="outlined-basic" variant="outlined" placeholder='$ 99' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='pricedrp'>
                                                            Prices are in USD, but payouts will be in your local currency.
                                                        </div>
                                                        <div className="layerdiv">
                                                            <div className="comment2 display-1">
                                                                <div className='commentinput'>
                                                                    <FormControl fullWidth>
                                                                        {/* <InputLabel id="demo-simple-select-label">Age</InputLabel> */}
                                                                        <Select
                                                                            labelId="demo-simple-select-label"
                                                                            id="demo-simple-select"
                                                                            value={selectAge}
                                                                            label="Age"
                                                                            onChange={handleSelectAge}
                                                                        >
                                                                            <MenuItem value={10}>What country is your bank account in?</MenuItem>
                                                                            <MenuItem value={20}>Twenty</MenuItem>
                                                                            <MenuItem value={30}>Thirty</MenuItem>
                                                                        </Select>
                                                                    </FormControl>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="setval text-center">
                                                            <Button>
                                                                SET VALUE
                                                            </Button>
                                                        </div>
                                                    </> : pg === 2 ? <>

                                                        <div className='puntext'>
                                                            Pay via dster
                                                        </div>

                                                        <div className="layerdiv">
                                                            <div className="comment2 display-1">
                                                                <div className='commentinput'>
                                                                    <TextField id="outlined-basic" variant="outlined" placeholder='$ 99' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='pricedrp'>
                                                            Prices are in USD, but payouts will be in your local currency.
                                                        </div>

                                                        <div className="setval text-center">
                                                            <Button>
                                                                SET VALUE
                                                            </Button>
                                                        </div>
                                                    </> : <>

                                                        <div className='puntext'>
                                                            Select Payment method
                                                        </div>

                                                        <div className='border-lye' >

                                                            <Button onClick={(() => { handlePg(1) })}>
                                                                Dster Token
                                                            </Button>

                                                        </div>
                                                        <div className='border-lye'>
                                                            <Button className='' onClick={() => { handlePg(2) }}>
                                                                Via strip
                                                            </Button>
                                                        </div>
                                                    </>}
                                                </div>

                                            </Box>
                                        </Modal>
                                    </div>

                                </CustomTabPanel>
                                <CustomTabPanel value={value3} index={3} className="categories">
                                    <Grid container>
                                        <Grid xs={12} sx={12} md={12} lg={8} xl={9}>
                                            <div className="subsc">
                                                Add category
                                            </div>
                                            <div className="layerdiv">
                                                <div className="commentinput2 display-1">
                                                    <div className='cmt2'>
                                                        <TextField id="outlined-basic" variant="outlined" placeholder='Name' />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="layerdiv">
                                                <div className="commentinput2 display-1">
                                                    <div className='cmt2'>
                                                        <TextField id="outlined-basic" variant="outlined" placeholder=' Group description' multiline rows={6} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="layerdiv">
                                                <div className="comment2 display-1">
                                                    <div className='commentinput'>
                                                        <FormControl fullWidth>
                                                            {/* <InputLabel id="demo-simple-select-label">Age</InputLabel> */}
                                                            <Select
                                                                labelId="demo-simple-select-label"
                                                                id="demo-simple-select"
                                                                value={selectAge}
                                                                label="Age"
                                                                onChange={handleSelectAge}
                                                            >
                                                                <MenuItem value={10}>What country is your bank account in?</MenuItem>
                                                                <MenuItem value={20}>Twenty</MenuItem>
                                                                <MenuItem value={30}>Thirty</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="display-1 decision-btn">
                                                <div className="adprice">
                                                    <div className='upload-next-btn adpr text-center' >
                                                        <Button onClick={handleOpen3}>
                                                            Add
                                                        </Button>
                                                    </div>
                                                </div>
                                                <div className='border-lye' style={{ margin: '25px' }}>

                                                    <Button style={{ height: '60px' }} onClick={() => { handlePg(2) }}>
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </CustomTabPanel>
                                <CustomTabPanel value={value3} index={4}>
                                    <Grid container>
                                        <Grid xs={12} sx={12} md={12} lg={8} xl={9}>
                                            {editPlug ? <>
                                                <div className="subsc display-1">
                                                    Membership questions<span>{switchs}</span>
                                                </div>
                                                <div className="display-1 margin-t-100px">
                                                    <div className='upload-next-btn  text-center' style={{ marginTop: '0px' }}>
                                                        <Button>
                                                            + Add Question
                                                        </Button>
                                                    </div>
                                                    <div className="askmem">
                                                        Ask members up to three questions when they request to join your group. Only admins and moderators will see the answers. You can send new members questions/answers to your CRM using Zapier.
                                                    </div>
                                                </div>
                                                <div className="layerdiv" style={{ width: '100%', marginTop: '50px' }}>
                                                    <div className="commentinput2 display-2">
                                                        <div className="display-1">
                                                            <div className=''>
                                                                <div className="display-1">
                                                                    <div className="q1">
                                                                        Q1
                                                                    </div>
                                                                    <div className="tsetgrp">
                                                                        Enter your subscripted Mail ID
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="display-1">
                                                            <div className="rmve">
                                                                <Button variant='contained' onClick={handleEditPlug}>
                                                                    Remove
                                                                </Button>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="layerdiv" style={{ width: '100%', marginTop: '50px' }}>
                                                    <div className="commentinput2 display-2">
                                                        <div className="display-1">
                                                            <div className=''>
                                                                <div className="display-1">
                                                                    <div className="q1">
                                                                        Q2
                                                                    </div>
                                                                    <div className="tsetgrp">
                                                                        <div className="commentinput2 display-1">
                                                                            <div className='cmt2'>
                                                                                <TextField id="outlined-basic" variant="outlined" placeholder='Type Here' />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="display-1">
                                                            <div className="crrprice">
                                                                <Button variant='contained'>
                                                                    Save
                                                                </Button>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="add-qurst cursor">
                                                    + Add Question
                                                </div>
                                            </> : <>

                                                <div className="subsc">
                                                    Plugins
                                                </div>
                                                <div className="display-1">
                                                    <div className="layerdiv" style={{ width: '100%', marginTop: '0px' }}>
                                                        <div className="commentinput2 display-2">
                                                            <div className="display-1">
                                                                <div className=''>
                                                                    <div className="display-1 membership">
                                                                        <div className="tg" style={{
                                                                            background: selectedColor ? selectedColor : "linear-gradient(274.4deg, #175AFF 2.38%, #FC5AFF 97.31%)"
                                                                        }}>

                                                                            TG
                                                                        </div>
                                                                        <div className="tsetgrp">
                                                                            Membership questions<span style={{
                                                                                color: '#51DC8E'
                                                                            }}>(ON)</span>
                                                                            <div className="tses-dc">
                                                                                Ask members questions when they request access to your group.
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div className="display-1 edit-btn">
                                                                <div className="crrprice2">
                                                                    <Button variant='contained' onClick={handleEditPlug}>
                                                                        Edit
                                                                    </Button>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>


                                                </div>

                                            </>}

                                        </Grid>
                                    </Grid>
                                </CustomTabPanel>
                                <CustomTabPanel value={value3} index={5} className="gamification">
                                    <Grid container>
                                        <Grid xs={12} sx={12} md={12} lg={8} xl={9}>

                                            <div className="subsc display-1">
                                                Gamification
                                            </div>
                                            {['', '', '', ''].map((row, i) => {
                                                return (
                                                    <div className="layerdiv" style={{ width: '100%', marginTop: '50px' }}>
                                                        <div className="commentinput2 display-2">
                                                            <div className="display-1">
                                                                <div className=''>
                                                                    <div className="display-1 level-up">
                                                                        <div className="q1">
                                                                            Level {i + 1}
                                                                        </div>
                                                                        <div className="tsetgrp">
                                                                            Membership questions
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div className="display-1">
                                                                <div className="crrprice2">
                                                                    <Button variant='contained' onClick={handleEditPlug}>
                                                                        Edit
                                                                    </Button>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>

                                                )
                                            })}


                                        </Grid>
                                    </Grid>
                                </CustomTabPanel>
                            </> : <>
                                <CustomTabPanel value={value} index={0}>
                                    <div className="layerdiv">
                                        <div className="comment display-1">
                                            <Avatar
                                                alt="Remy Sharp"
                                                src="https://s.france24.com/media/display/451ed2b8-eed6-11ea-afdd-005056bf87d6/w:1280/p:4x3/messi-1805.jpg"
                                                sx={{ width: 40, height: 40 }}
                                            />
                                            <div className='commentinput'>
                                                <TextField style={{ width: '100%' }} id="outlined-basic" variant="outlined" placeholder='Write Something' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="innertab-com">
                                        <Box>
                                            <Tabs value={value2} onChange={handleChange2} aria-label="basic tabs example" className='bcknewTab cmd' variant="scrollable"
                                                scrollButtons
                                                allowScrollButtonsMobile>
                                                <Tab label={
                                                    <div className='tab-bor'>
                                                        All
                                                    </div>
                                                } {...a11yProps(0)} />
                                                <Tab label={<div className='tab-bor'>
                                                    General discussionl
                                                </div>}{...a11yProps(1)} />
                                            </Tabs>
                                        </Box>
                                        <CustomTabPanel value={value2} index={0}>
                                            <div className="startofspec">
                                                This is the start of something special
                                            </div>
                                        </CustomTabPanel>
                                        <CustomTabPanel value={value2} index={1}>
                                            Item Three
                                        </CustomTabPanel>
                                    </div>
                                </CustomTabPanel>
                                <CustomTabPanel value={value} index={1}>
                                    two
                                </CustomTabPanel>
                                <CustomTabPanel value={value} index={2}>
                                    <div className="layerdiv">
                                        <div className="commentinput2 " style={{ padding: '20px' }}>
                                            <div className="sett text-right">
                                                <svg width="32" height="34" viewBox="0 0 32 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.7084 5.30769L12.7668 2.57538C12.9454 2.11277 13.2594 1.71486 13.6679 1.43375C14.0764 1.15265 14.5602 1.00146 15.0561 1H17.0745C17.5704 1.00146 18.0542 1.15265 18.4627 1.43375C18.8712 1.71486 19.1853 2.11277 19.3638 2.57538L20.4222 5.30769L24.0161 7.37538L26.9207 6.93231C27.4043 6.86666 27.8966 6.94628 28.3349 7.16104C28.7732 7.37581 29.1377 7.71602 29.3822 8.13846L30.3668 9.86154C30.6192 10.2907 30.7354 10.7863 30.7002 11.2829C30.6651 11.7795 30.4802 12.2537 30.1699 12.6431L28.373 14.9323V19.0677L30.2192 21.3569C30.5294 21.7463 30.7143 22.2205 30.7495 22.7171C30.7846 23.2137 30.6684 23.7093 30.4161 24.1385L29.4315 25.8615C29.187 26.284 28.8224 26.6242 28.3841 26.839C27.9458 27.0537 27.4536 27.1333 26.9699 27.0677L24.0653 26.6246L20.4715 28.6923L19.413 31.4246C19.2345 31.8872 18.9204 32.2851 18.512 32.5662C18.1035 32.8474 17.6196 32.9985 17.1238 33H15.0561C14.5602 32.9985 14.0764 32.8474 13.6679 32.5662C13.2594 32.2851 12.9454 31.8872 12.7668 31.4246L11.7084 28.6923L8.11454 26.6246L5.20992 27.0677C4.72627 27.1333 4.23402 27.0537 3.79573 26.839C3.35743 26.6242 2.99287 26.284 2.74838 25.8615L1.76377 24.1385C1.51147 23.7093 1.39522 23.2137 1.43038 22.7171C1.46553 22.2205 1.65044 21.7463 1.96069 21.3569L3.75762 19.0677V14.9323L1.91146 12.6431C1.60121 12.2537 1.4163 11.7795 1.38115 11.2829C1.34599 10.7863 1.46223 10.2907 1.71454 9.86154L2.69915 8.13846C2.94364 7.71602 3.3082 7.37581 3.74649 7.16104C4.18479 6.94628 4.67704 6.86666 5.16069 6.93231L8.06531 7.37538L11.7084 5.30769ZM11.1422 17C11.1422 17.9737 11.431 18.9255 11.9719 19.7351C12.5129 20.5447 13.2818 21.1757 14.1813 21.5483C15.0809 21.9209 16.0708 22.0184 17.0258 21.8285C17.9807 21.6385 18.8579 21.1696 19.5464 20.4811C20.235 19.7926 20.7038 18.9154 20.8938 17.9604C21.0837 17.0055 20.9863 16.0156 20.6136 15.116C20.241 14.2164 19.61 13.4476 18.8004 12.9066C17.9908 12.3657 17.039 12.0769 16.0653 12.0769C14.7596 12.0769 13.5074 12.5956 12.5842 13.5189C11.6609 14.4421 11.1422 15.6943 11.1422 17V17Z" stroke="#B8B8B8" stroke-width="1.95871" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>
                                            <div className="display-2">
                                                <div className="lb-name">
                                                    Tarisa Elan
                                                    <div className="artist-bg">
                                                        Artist
                                                    </div>
                                                </div>
                                                <div className="">
                                                    <Avatar
                                                        alt="Remy Sharp"
                                                        src="https://s.france24.com/media/display/451ed2b8-eed6-11ea-afdd-005056bf87d6/w:1280/p:4x3/messi-1805.jpg"
                                                        sx={{ width: 180, height: 180 }}
                                                    />
                                                </div>
                                                <div className="points-toup">
                                                    3 points to level up
                                                </div>
                                            </div>
                                            <div className="margin-top display-1" style={{ flexWrap: 'wrap' }}>
                                                {['', '', '', '', '', '', '', '', '', ''].map((row, i) => {
                                                    return (
                                                        <div className="layerdiv lvl-layer" style={{ width: 'fit-content' }}>
                                                            <div className="commentinput2 display-1 lvl-main cursor">
                                                                <div className="lvl">
                                                                    L{i + 1}
                                                                </div>
                                                                <div className="lvl-txt">
                                                                    Level {i + 1}
                                                                    <div className="lvl-mem">
                                                                        0% of members
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}

                                            </div>
                                        </div>

                                    </div>
                                </CustomTabPanel>
                                <CustomTabPanel value={value} index={3}>
                                    <Grid container>
                                        <Grid xs={12} sx={12} md={12} lg={12} xl={12}>
                                            <div className="textgrp">
                                                Test Group
                                            </div>
                                            <div className="test-vido cursor" onClick={handleOpenM4}>
                                                Upload images / videos
                                            </div>
                                            <div className="sct-div margin-top">
                                                <Stack direction="row" spacing={2}>
                                                    <div className="display-1">
                                                        <LockIcon />
                                                        <div className="abt-stk-text">
                                                            Private group
                                                        </div>
                                                    </div>
                                                    <div className="display-1">
                                                        <GroupIcon />
                                                        <div className="abt-stk-text">
                                                            6.5k members
                                                        </div>
                                                    </div>
                                                    <div className="display-1">
                                                        <LocalOfferIcon />
                                                        <div className="abt-stk-text">
                                                            Free
                                                        </div>
                                                    </div>
                                                    <div className="display-1">
                                                        <Avatar sx={{ width: 30, height: 30 }} src="https://imgs.search.brave.com/gTGcFA5drHatTMbjYOP3X-CROolnU7u_bxbi4rdlrWg/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/ZnJlZS1waG90by9y/ZWxheGVkLWFmcmlj/YW4tZ2lybC13aXRo/LWJpZy1leWVzLXNt/aWxpbmctYXBwZWFs/aW5nLWxhZHktbGlz/dGVuaW5nLW11c2lj/LXdoaXRlXzE5NzUz/MS0xMTI4MS5qcGc_/c2l6ZT02MjYmZXh0/PWpwZw" alt="Remy Sharp" />
                                                        <div className="abt-stk-text">
                                                            By Antonio Centeno
                                                        </div>
                                                    </div>



                                                </Stack>
                                            </div>
                                        </Grid>
                                    </Grid>
                                    <Modal
                                        open={openModel4}
                                        // onClose={handleClose4}
                                        aria-labelledby="modal-modal-title"
                                        aria-describedby="modal-modal-description"
                                    >
                                        <Box sx={style2}>
                                            <div style={{ background: 'var(--clr-bcg3)', borderRadius: '12px', padding: '20px 50px', height: '100%' }}>
                                                <div className='text-left' style={{
                                                    position: 'relative',
                                                    left: '-35px'
                                                }}>
                                                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={handleCloseM4}>
                                                        < path d="M0.806643 14.4092C0.299284 13.9018 0.299285 13.0792 0.806644 12.5719L12.5719 0.806641C13.0792 0.299282 13.9018 0.299282 14.4092 0.806641C14.9165 1.314 14.9165 2.13659 14.4092 2.64395L2.64395 14.4092C2.13659 14.9165 1.314 14.9165 0.806643 14.4092ZM0.801271 2.62783C0.296879 2.12344 0.296879 1.30566 0.801271 0.801269C1.30566 0.296877 2.12344 0.296877 2.62783 0.801269L14.4146 12.588C14.9189 13.0924 14.9189 13.9102 14.4146 14.4145C13.9102 14.9189 13.0924 14.9189 12.588 14.4145L0.801271 2.62783Z" fill="white" />
                                                    </svg>
                                                </div>
                                                <div className='puntext'>
                                                    Add media
                                                </div>
                                                <div className="reco">
                                                    Upload an image (1400 x 790 recommended).
                                                </div>

                                                <div className="setval text-center">
                                                    <Button style={{ width: 'fit-content' }}>
                                                        Upload Image
                                                    </Button>
                                                </div>
                                                <div className='pricedrp text-center'>
                                                    Or, add a YouTube, Vimeo, loom or video link
                                                </div>

                                                <div className="layerdiv">
                                                    <div className="comment2 display-1">
                                                        <div className='commentinput'>
                                                            <TextField id="outlined-basic" variant="outlined" placeholder='Link' />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="display-2">
                                                    <div className='border-lye' style={{ margin: '0' }}>

                                                        <Button sx={{ width: 'fit-content !important' }}>
                                                            Cancel
                                                        </Button>

                                                    </div>
                                                    <div className="setting" >
                                                        <Button onClick={handleSetting} >
                                                            Add
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>

                                        </Box>
                                    </Modal>
                                </CustomTabPanel>

                            </>}
                        </Grid>
                        {!setting ? <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={4}
                            style={{ padding: '20px' }}
                        >
                            <div>
                                <div className='bck-inner-mian'>
                                    <div className='bckcmt-img text-center'>
                                        {imageUrl ?
                                            <img src={imageUrl} alt='join-button' />
                                            : uploadImageDiv
                                        }

                                    </div>
                                    <div className="display-1 tg-mian">
                                        <div className="tg" style={{
                                            background: selectedColor ? selectedColor : "linear-gradient(274.4deg, #175AFF 2.38%, #FC5AFF 97.31%)"
                                        }}>

                                            TG
                                        </div>
                                        <div className="tsetgrp">
                                            Test Group
                                        </div>
                                    </div>
                                    <div className='p-skllink cmt-rit'>
                                        Add your group description here
                                        by clicking the "Settings" button.
                                    </div>


                                    <Stack
                                        direction="row"
                                        divider={<Divider orientation="vertical" flexItem className='divborder' />}
                                        spacing={2}
                                        className='stck-n-card'
                                    >
                                        <div className='rmr text-center'>
                                            6.5k
                                            <div className='adm'>
                                                Members
                                            </div>
                                        </div>
                                        <div className='rmr text-center'>
                                            40
                                            <div className='adm'>
                                                Online
                                            </div>
                                        </div>
                                        <div className='rmr text-center'>
                                            5
                                            <div className='adm'>
                                                Admins
                                            </div>
                                        </div>
                                    </Stack>
                                    <div className="setting" >
                                        <Button onClick={handleSetting}>
                                            Settings
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Grid> : null}
                    </Grid>
                </Box>
            </Box>
        </div>
    )
}

export default BckPassCreate 
